import {TabsPage} from "../pages/both/tabs/tabs";
import {ProfileAuthPage} from "../pages/sync/profile-auth/profile-auth";
import {ProfileMenuPage} from "../pages/sync/profile-menu/profile-menu";
import {ProfilePagePage} from "../pages/sync/profile-page/profile-page";
import {ShowbookPage} from "../pages/show/showbook/showbook";
import {ShowopenPage} from "../pages/show/showopen/showopen";
import {ShowdeskPage} from "../pages/show/showdesk/showdesk";
import {ShowfilaPage} from "../pages/show/showfila/showfila";
import {ShowsyncPage} from "../pages/show/showsync/showsync";
import {ShowviewPage} from "../pages/show/showview/showview";
import {ShowhourPage} from "../pages/show/showhour/showhour";
import {WebsiteOlhaPage} from "../pages/sync/website-olha/website-olha";
import {DesktopMenuPage} from "../pages/sync/desktop-menu/desktop-menu";

export const AFTER_LOGIN = {
    tabsmenu:        TabsPage,
    logado:          ProfileMenuPage,
    profile:         ProfilePagePage,
    showdive:        ShowbookPage,
    showhour:        ShowhourPage,
    showopen:        ShowopenPage,
    showsync:        ShowsyncPage,
    showdesk:        ShowdeskPage,
    showfila:        ShowfilaPage,
    desktop:         DesktopMenuPage,
    showview:        ShowviewPage,
    siteolha:        WebsiteOlhaPage,

    password:        ProfileAuthPage,
};

export const AFTER_LOGOUT = {
    register:        ProfileAuthPage,
    password:        ProfileAuthPage,
    showopen:        ShowopenPage,
    showsync:        ShowsyncPage,
    showdesk:        ShowdeskPage,
    showfila:        ShowfilaPage,
    desktop:         DesktopMenuPage,
    showview:        ShowviewPage,
    siteolha:        WebsiteOlhaPage,
};

export const CLOSE_PAGE = {
    proauth:         ProfileAuthPage,
};




// WEBPACK FOOTER //
// ./src/app/import.ts